module.exports = __webpack_public_path__ + "img/ph.12f36eed.svg";